import { convertToArray, tryRemovePrefix, tryRemoveSuffix, zipShortest } from 'common/helpers'
import type { NonCollapsableWithPrimitive } from 'common/types'

export const PagesUrls = {
  Project: '/project',
  Stratigraphy: '/stratigraphy',
  Cartography: '/cartography',
  Modeling: '/modeling',
  Interpretation: '/interpretation',
  DataManager: '/data-manager',
  CrossPlot: '/cross-plot',
} as const

export const KnownSuffixes = {
  BulkImport: 'bulk',
  StratigraphyPlanchette: 'planchette',
  StratigraphyModeling: 'modeling',
} as const

type KnownSuffixesNames = keyof typeof KnownSuffixes
type KnownSuffixes = (typeof KnownSuffixes)[KnownSuffixesNames]

type PathSegment = NonCollapsableWithPrimitive<string> | KnownSuffixes

type Urls = keyof typeof PagesUrls

type CreateUrlOptions = {
  base: Urls
  path?: PathSegment | PathSegment[]
  query?: Record<string, string>
  full?: boolean
}

export function createUrlTo({ base, full, path, query }: CreateUrlOptions) {
  let route = PagesUrls[base]
  if (path) {
    const paths = convertToArray(path).map(removeLeadingAndTrailingSlashes).join('/')
    route += `/${paths}`
  }

  if (query) {
    const searchParams = new URLSearchParams(query)
    route += `?${searchParams.toString()}`
  }

  if (full) {
    return [window.location.href, route].map(removeLeadingAndTrailingSlashes).join('/')
  }

  return route
}

export function removeLeadingAndTrailingSlashes(value: string) {
  const stripped = tryRemovePrefix(value, '/')
  return tryRemoveSuffix(stripped, '/')
}

export function isSubpath(baseUrl: string, subpathUrl: string) {
  const [baseSegments, subpathSegments] = [baseUrl, subpathUrl].map(path =>
    removeLeadingAndTrailingSlashes(path.split('?').at(0) ?? '').split('/'),
  )

  return zipShortest(baseSegments, subpathSegments).every(([one, other]) => one === other)
}
